var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50025 11.5C2.87393 11.4999 2.25912 11.3317 1.71995 11.013C1.18078 10.6943 0.737017 10.2367 0.434945 9.68803C0.132873 9.13937 -0.0164364 8.5197 0.00259268 7.89366C0.0216217 7.26763 0.208292 6.65817 0.54313 6.12887C0.877968 5.59956 1.34871 5.16981 1.90624 4.88443C2.46377 4.59905 3.08766 4.46851 3.71283 4.50642C4.33801 4.54433 4.94156 4.74931 5.46051 5.09996C5.97947 5.45062 6.39483 5.93411 6.66325 6.5H14.0003L15.5003 8L14.0003 9.5L13.0003 8.5L12.0003 9.5L11.0003 8.5L10.0003 9.5L9.00025 8.5L8.00025 9.5H6.66325C6.37935 10.0985 5.93141 10.6042 5.3715 10.9582C4.81159 11.3123 4.1627 11.5001 3.50025 11.5ZM2.50025 9C2.76547 9 3.01982 8.89464 3.20736 8.70711C3.3949 8.51957 3.50025 8.26522 3.50025 8C3.50025 7.73478 3.3949 7.48043 3.20736 7.29289C3.01982 7.10536 2.76547 7 2.50025 7C2.23504 7 1.98068 7.10536 1.79315 7.29289C1.60561 7.48043 1.50025 7.73478 1.50025 8C1.50025 8.26522 1.60561 8.51957 1.79315 8.70711C1.98068 8.89464 2.23504 9 2.50025 9Z",
    fill: "#003738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/keyIcon.0d174e51c1cfa0d619ffc98711a93189.svg";
export { ForwardRef as ReactComponent };